// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".closed[data-v-29e8a1df]{text-align:left}.title[data-v-29e8a1df]{color:#191919;margin:0}@media (max-width:768px){.title[data-v-29e8a1df]{font-size:16px;line-height:20px;padding-bottom:15px}}@media (min-width:768px){.title[data-v-29e8a1df]{font-size:25px;line-height:1.2;padding-bottom:30px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
